
      // Flag to check if main JS loaded
      window.mainJSLoaded = false;
    